import * as Yup from 'yup'

const loyaltyCardValidator = Yup.object ({
  name: Yup.string ()
    .required ('Digite um nome')
    .min (4, 'O nome deve conter no minimo 4 caracteres')
    .max (128, 'O nome deve conter até 128 caracteres'),

  description: Yup.string ()
    .required ('Digite uma descrição')
    .min (4, 'A descrição deve conter no minimo 4 caracteres')
    .max (256, 'A descrição deve conter até 256 caracteres'),

  type: Yup.object ()
    .nullable ()
    .required ('Selecione um tipo'),

  requiredVisits: Yup.number ()
    .min (1, 'Insira um número de visitas válido')
    .required ('Digite a quantidade de visitas necessárias'),

  requiredSpent: Yup.number ().when ('type', {
    is: type => type?.value === 'spent',
    then: schema => {
      schema.required ('Digite o valor gasto necessário').min (1, 'Insira um valor válido')
    },
    otherwise: schema => schema.notRequired ()
  }),

  expiresAt: Yup.string ().nullable (),

  services: Yup.array ().of (Yup.object ().shape ({
    id: Yup.string (),
    name: Yup.string ().when ('$type', {
      is: type => type?.value === 'service',
      then: schema => schema.required ('Selecione um serviço'),
      otherwise: schema => schema.notRequired ()
    }),
    amount: Yup.number ()
  })),

  rewards: Yup.array ().of (Yup.object ().shape ({
    service_id: Yup.string (),
    name: Yup.string ().when ('$type', {
      is: type => type?.value === 'service',
      then: schema => schema.required ('Selecione uma recompensa'),
      otherwise: schema => schema.notRequired ()
    }),
    amount: Yup.number ()
  }))
})

export default loyaltyCardValidator
